import Select from "react-select";
import { useTranslation } from "react-i18next";

function DropDown({ data, value, onChange, optionlables, placeholder, multiple = false }) {
  const [il8n] = useTranslation();

  return (
    <Select
      isMulti={multiple} // ✅ يدعم الاختيار المتعدد حسب prop
      className="basic-single"
      classNamePrefix="select"
      isClearable
      options={data}
      getOptionLabel={optionlables}
      getOptionValue={(option) => option.id || option.PERMISSION_NAME} // ضمان قيمة فريدة
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      theme={(theme) => ({
        ...theme,
        direction: il8n.language === "en" ? "ltr" : "rtl",
      })}
      styles={{
        control: (base) => ({
          ...base,
          direction: il8n.language === "en" ? "ltr" : "rtl",
        }),
        menu: (base) => ({
          ...base,
          direction: il8n.language === "en" ? "ltr" : "rtl",
        }),
      }}
    />
  );
}

export default DropDown;
